const MyPostSkeleton = () => {
  return (
    <div className="p-4 border border-gray-200 dark:border-slate-700 rounded-xl animate-pulse">
      <div className="space-y-3">
        <div className="h-4 w-full bg-gray-200 dark:bg-slate-700 rounded" />
        <div className="h-4 w-3/4 bg-gray-200 dark:bg-slate-700 rounded" />
        <div className="flex gap-4 mt-2">
          <div className="h-3 w-16 bg-gray-200 dark:bg-slate-700 rounded" />
          <div className="h-3 w-16 bg-gray-200 dark:bg-slate-700 rounded" />
          <div className="h-3 w-24 bg-gray-200 dark:bg-slate-700 rounded" />
        </div>
      </div>
    </div>
  );
};

export default MyPostSkeleton;